

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import App from './App'
import bus from './bus'
Vue.use(VueRouter)
Vue.use(AjaxPlugin)
Vue.use(LoadingPlugin)
Vue.prototype.bus = bus
const routes = [
{path: '/', redirect: '/home'},
{path: '/login', component: function (resolve) { require(['./components/login'], resolve) }},
{path: '/hello', component: require('./components/Hello')},
{path: '/home', component: function (resolve) { require(['./components/menugrid'], resolve) }},
{path: '/menu', component: function (resolve) { require(['./components/menulist'], resolve) }},
{path: '/menuedit', component: function (resolve) { require(['./components/menuedit'], resolve) }},
{path: '/payment', component: function (resolve) { require(['./components/payment.vue'], resolve) }},
{path: '/ord2storage', component: function (resolve) { require(['./pages/orderstorage.vue'], resolve) }},
{path: '/os2list', name: 'os2list', component: function (resolve) { require(['./pages/orderstorage2list.vue'], resolve) }},
{path: '/ord2car', name: 'ord2car', component: function (resolve) { require(['./pages/OrderCar.vue'], resolve) }},
{path: '/ord2line', component: function (resolve) { require(['./pages/OrderLine.vue'], resolve) }},
{path: '/ord2recadd', component: function (resolve) { require(['./pages/OrderRecadd.vue'], resolve) }},
{path: '/ord2recaddn', component: function (resolve) { require(['./pages/OrderRecaddnew.vue'], resolve) }},
{path: '/bill2account', component: function (resolve) { require(['./pages/billInquireies.vue'], resolve) }},
{path: '/deli2rec', component: function (resolve) { require(['./pages/deliveryRec.vue'], resolve) }},
{path: '/saleservice', component: function (resolve) { require(['./pages/saleservice.vue'], resolve) }}
]
const router = new VueRouter({
routes
})
FastClick.attach(document.body)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js